import React, { useEffect, useState} from "react";
import { listBuyerRFQs } from "../../api/buyerRFQ.api";
import DataTable from "react-data-table-component";
import StatusBadge from "../../components/StatusBadge";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "reactstrap";

const BuyerRFQs = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [selectedRFQ, setSelectedRFQ] = useState(null);
  const [tooltips, setTooltips] = useState({
    viewDetails: false,
    closeModal: false
  });

  const toggleTooltip = (tooltipName) => {
    setTooltips(prev => ({
      ...prev,
      [tooltipName]: !prev[tooltipName]
    }));
  };

  useEffect(() => {

    listBuyerRFQs({
      skip: 0,
      per_page: 100
    }).then(res => {

      if (res.data.data.length > 0) {

        setData(res.data.data[0].data);

      }

    });

  }, []);

  const columns = [

{
  name: "Product",
  grow: 2,
  cell: r => (
    <span
      onClick={() => navigate(`/product/${r.listed_product_id}`)}
      style={{
        fontWeight: "700",
        color: "#112347",
        cursor: "pointer",
        textDecoration: "underline"
      }}
    >
      {r.product_name}
    </span>
  )
},

    {
      name: "Seller",
      selector: r => r.business_name,
      grow: 2
    },

    {
      name: "Quantity",
      selector: r => r.quantity,
      center: true
    },

    {
      name: "Status",
      center: true,
      cell: r => (
        <StatusBadge status={r.status} />
      )
    },

    {
      name: "Actions",
      right: true,
      cell: r => (
        <>
          <button
            id={`viewDetailsBtn-${r.id}`}
            className="btn btn-link text-muted fw-bold p-0 text-decoration-none text-nowrap"
            onClick={() => setSelectedRFQ(r)}
          >
            View Details →
          </button>
          <Tooltip placement="top" isOpen={tooltips[`viewDetailsBtn-${r.id}`]} target={`viewDetailsBtn-${r.id}`} toggle={() => setTooltips(prev => ({...prev, [`viewDetailsBtn-${r.id}`]: !prev[`viewDetailsBtn-${r.id}`]}))}>
            View RFQ details and quoted price
          </Tooltip>
        </>
      )
    }

  ];

  return (

    <div
      style={{
        backgroundColor: "#ffffff",
        padding: "clamp(15px, 3vw, 24px)",
        borderRadius: "12px",
        border: "1px solid #e5e7eb"
      }}
    >

      <h5
        className="fw-bold mb-4"
        style={{ color: "#112347" }}
      >
        Request for Quotations
      </h5>

      {/* TABLE */}
      <div className="table-responsive border rounded-3 overflow-hidden">

        <DataTable
          columns={columns}
          data={data}
          pagination
        />

      </div>

      {/* MODAL */}
      {selectedRFQ && (

        <div
          onClick={() => setSelectedRFQ(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 99999,
            padding: "20px"
          }}
        >

          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "30px",
              width: "100%",
              maxWidth: "500px",
              position: "relative"
            }}
          >

            {/* CLOSE */}
            <span
              id="closeModalBtn"
              onClick={() => setSelectedRFQ(null)}
              style={{
                position: "absolute",
                top: "15px",
                right: "20px",
                cursor: "pointer",
                fontSize: "22px",
                fontWeight: "bold"
              }}
            >
              ✕
            </span>
            <Tooltip placement="left" isOpen={tooltips.closeModal} target="closeModalBtn" toggle={() => toggleTooltip('closeModal')}>
              Close this window
            </Tooltip>

            <h4
              className="fw-bold mb-4"
              style={{ color: "#112347" }}
            >
              RFQ Details
            </h4>

            <div className="mb-3">

              <small className="text-muted d-block">
                Product
              </small>

              <div className="fw-bold">
                {selectedRFQ.product_name}
              </div>

            </div>

            <div className="mb-3">

              <small className="text-muted d-block">
                Seller
              </small>

              <div className="fw-bold">
                {selectedRFQ.business_name}
              </div>

            </div>

            <div className="mb-3">

              <small className="text-muted d-block">
                Quantity
              </small>

              <div className="fw-bold">
                {selectedRFQ.quantity}
              </div>

            </div>

            <div className="mb-3">

              <small className="text-muted d-block">
                RFQ Sent On
              </small>

              <div className="fw-bold">
                {
                  selectedRFQ.created_at
                    ? new Date(
                        selectedRFQ.created_at
                      ).toLocaleString()
                    : "-"
                }
              </div>

            </div>

            <div className="mb-3">



            </div>

            <div className="mt-4">

              <StatusBadge
                status={selectedRFQ.status}
              />

            </div>

          </div>

        </div>

      )}

    </div>

  );

};

export default BuyerRFQs;